import { bindActionCreators } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import categoryActions from "../../../store/actions/items/categories/category.actions";
import HomeCategoryCardContainer from "./HomeCategoryCardContainer";

import "../../../styles/components/home/categories/homePageCategoryListComponent.scss";

export const HomePageCategoryListComponent = ({ categories }) => {
  if (!categories) return;

  return (
    <div className=" homeCategoriesContainer">
      <h1>קטלוג מוצרים</h1>
      <div className="homeCategoryListContainer">
        {categories.map((category) => {
          return <HomeCategoryCardContainer key={category.id} category={category} />;
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  categories: state.categoryReducer.categories?.items, // Subscribe to categories state from the reducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    categoryActions: bindActionCreators(categoryActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePageCategoryListComponent);
